import { render, staticRenderFns } from "./DrugsDetail.vue?vue&type=template&id=3f20a880&scoped=true"
import script from "./DrugsDetail.vue?vue&type=script&lang=js"
export * from "./DrugsDetail.vue?vue&type=script&lang=js"
import style0 from "./DrugsDetail.vue?vue&type=style&index=0&id=3f20a880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20a880",
  null
  
)

export default component.exports